import styled from 'styled-components';

import {
  Backdrop as MUIBackdrop,
  Button as MUIButton,
  DialogActions as MUIDialogActions,
  DialogTitle as MUIDialogTitle,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { Z_INDEX_COMPONENT_LEVEL } from 'modules/mobiCopilot/utils/constants';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
`;

export const Title = withStyles({
  root: {
    padding: 0,
    '& > .MuiTypography-root': {
      fontFamily: "'Poppins Bold'",
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      color: '#424242',
    },
  },
})(MUIDialogTitle);

export const Content = styled('div')`
  font-family: 'Poppins Regular';
  font-size: 1rem;
  line-height: 1.25rem;
  color: #757575;
  margin: 0;

  strong {
    font-family: 'Poppins Bold';
  }
`;

export const Actions = withStyles({
  root: {
    padding: 0,
  },
})(MUIDialogActions);

export const ActionButton = withStyles({
  root: {
    textTransform: 'inherit',
    fontFamily: "'Poppins Medium'",
    color: '#424242',
    minWidth: '80px',
    '&.confirm': {
      backgroundColor: '#F44336',
      color: '#FFF',
    },
  },
})(MUIButton);

export const Backdrop = withStyles({
  root: {
    color: '#FFF',
    zIndex: Z_INDEX_COMPONENT_LEVEL,
  },
})(MUIBackdrop);
